export default __webpack_public_path__ + "static/media/Clear.6e4f36b6.png";